import { h } from "preact";
function DeliveryFormItemWrapper(props) {
    const { name, children } = props;
    return (h("div", { class: `m-delivery-address__item m-delivery-address__item--${name}` }, children));
}
export default DeliveryFormItemWrapper;
